import { APIImobsaleUrl, APICadimo5Url } from "../../config/constants";
export const API_VENDAS = `${APIImobsaleUrl}`;
export const API_CADIMO5 = `${APICadimo5Url}`;

export const DESTAQUE_ALUGUEL = 1;
export const DESTAQUE_VENDA = 2;

export const VANTAGEM_INQUILINO = 1;
export const VANTAGEM_PROPRIETARIO = 2;
export const VANTAGEM_COMPRADOR = 3;